module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114139_103_157.60dbb78.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114139_103_157.jpg
// module id = xbGj
// module chunks = 0